import { FavouriteTransfersListFilters, FavouriteTransfersState } from './types';

const initialFavouriteTransfersListFilters = { pageSize: 10, pageOffset: 0 };

const defaultState: FavouriteTransfersState = {
  action: null,
  currencies: [],
  selectedFavouriteTransfer: null,
  favouriteTransfersListFilters: initialFavouriteTransfersListFilters,
  favouriteTransferToEdit: null,
  favouriteTransferToDelete: null,
  editFavouriteTransferData: null,
  deleteFavouriteTransferData: null,
  shouldShare: null,
  loadingState: {
    isLoadingFavouriteTransfersList: false,
    isLoadingEditFavouriteTransfer: false,
    isLoadingDeleteFavouriteTransfer: false,
    isLoadingCurrencies: false,
  },
  errorState: {
    favouriteTransfersDataError: undefined,
    editFavouriteTransferError: undefined,
    deleteFavouriteTransferError: undefined,
    currenciesError: undefined,
  },
  onFavouriteTransferListFiltersChange: (
    filters: Partial<FavouriteTransfersListFilters>,
    toToggleFilterDrawer?: boolean,
    nextPage?: number,
    totalPages?: number,
  ) => {},
  onFavouriteTransferAction: () => {},
  onEditFavouriteTransfer: alias => {},
  onDeleteFavouriteTransfer: () => {},
  onShareFavouriteTransfer: () => {},
  onUseTemplateFavouriteTransfer: () => {},
  onResetSelectedFavouriteTransfer: () => {},
  onResetFavouriteTransferListFilters: () => {},
  // favourite transfers filter drawer default state
  isFavouriteTransfersFilterDrawerOpen: false,
  toggleFavouriteTransfersFilterDrawer: () => {},
  setFavouriteTransfersFilterDrawerClose: () => {},
  meta: {
    timestamp: new Date().toISOString(),
  },
};

export { defaultState, initialFavouriteTransfersListFilters };
